export const API_URLS = {
  PRODUCTS: '/v1/products',
  TRENDYOL_GIFT_CODE: '/v1/products/trendyol/gift-code',
  VODAFONE_MOBILE_PACKAGE: '/v1/products/vodafone/mobile-package',
  TURK_TELEKOM_MOBILE_PACKAGE: '/v1/products/turk-telekom/mobile-package',
  TRENDYOL_GIFT_CODE_INIT: '/v1/products/trendyol/gift-code/init',
  TRENDYOL_GIFT_CODE_INIT_OTHER: '/v1/products/trendyol/gift-code/init-other',
  VODAFONE_MOBILE_PACKAGE_INIT: '/v1/products/vodafone/mobile-package/init',
  ADDRESSES: '/v1/addresses',
  CARTS_PAY: '/v1/carts/pay',
  CARTS_PAYMENT_OPTION: '/v1/carts/payment-option',
  PAYMENT_OPTIONS: '/v1/payment-options',
  CARTS_ADDRESS: '/v1/carts/address',
  GET_CART: '/v1/carts',
  CARDS: '/v1/cards',
  LOCATIONS: '/v1/locations/cities', // full url must be /v1/locations/cities/{cityId}/districts/{districtId}/neighborhoods
  ORDERS: '/v1/orders', // full url must be /v1/orders/{orderParenId}/summary, /v1/orders/{orderParentNumber}/contracts
  ORDERS_V2: '/v2/orders',
  INPUTS: '/v1/inputs', // full url must be /v1/inputs?seller=VODAFONE&productGroup=MOBILE_TL
  USER_DATA: '/v1/users/flags',
  UPLOAD_IMAGE: '/v1/products/trendyol/gift-code/personal-images',
  RAFFLE: '/v1/raffle',
  RAFFLE_V2: '/v2/raffle',
  USER_IDENTITY: '/v1/users/identity',
  CARD_OFFER: '/v1/card-offer',
  INVOICE: '/v1/invoice',
  MOBILE_TOPUP_INIT: '/v1/pre-order/top-up',
  RAFFLE_INIT: '/v1/pre-order/raffle',
  CHECKOUT_CART: '/v1/pre-order',
  CONTRACTS: '/v1/contracts',
};

export const PUBLIC_PATHS = ['/orders/contracts'];

export const BASE_URL = '/api';
